import React from "react";

const ExtrapayPageHeader = ({ icon = "pi pi-wallet", title, subtitle }) => (
  <div className="mb-4">
    <div className="flex align-items-center gap-3">
      <div
        className="border-circle flex align-items-center justify-content-center"
        style={{
          border: "1px solid var(--theme-border, #EBEBEB)",
          width: "42px",
          height: "42px",
        }}
      >
        <i className={`${icon} text-lg`} style={{ color: "var(--theme-text-muted, #5C5C5C)" }} />
      </div>
      <div>
        <h2 className="text-lg font-semibold m-0" style={{ color: "var(--theme-text)" }}>
          {title}
        </h2>
        {subtitle && (
          <p className="text-sm m-0 mt-1" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
            {subtitle}
          </p>
        )}
      </div>
    </div>
    <hr className="mt-4 mb-0" style={{ borderColor: "var(--theme-border, #EBEBEB)" }} />
  </div>
);

export default ExtrapayPageHeader;
